import type { NavigationGuardNext, NavigationGuardWithThis, RouteLocationNormalized } from 'vue-router';
import { getJobAvailability } from './services/jobs.service';
import { JOB_UNAVAILABLE } from './routing';
import { useCartStore } from './stores/cart.store';

export async function jobIsAvailableRouteGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  const cartStore = useCartStore();

  if (cartStore.persistedOrderMethod === 'Prepay' || cartStore.persistedOrderMethod === 'Gallery') {
    const jobIdString = to.params.jobId;
    if (typeof jobIdString === 'string') {
      const parsedJobId = parseInt(jobIdString);
      const availability = await getJobAvailability(parsedJobId);

      if (!availability.published || availability.archived) {
        next({ name: JOB_UNAVAILABLE, params: { jobId: parsedJobId } });
        return;
      }

      if (cartStore.persistedOrderMethod === 'Prepay' && !availability?.prepay?.available) {
        next({ name: JOB_UNAVAILABLE, params: { jobId: parsedJobId } });
        return;
      } else if (cartStore.persistedOrderMethod === 'Gallery' && !availability?.gallery?.available) {
        next({ name: JOB_UNAVAILABLE, params: { jobId: parsedJobId } });
        return;
      }
    }
  }

  next();
}
